import { render, staticRenderFns } from "./airBookingVessel.vue?vue&type=template&id=351add6a&scoped=true&"
import script from "./airBookingVessel.vue?vue&type=script&lang=js&"
export * from "./airBookingVessel.vue?vue&type=script&lang=js&"
import style0 from "./airBookingVessel.vue?vue&type=style&index=0&id=351add6a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "351add6a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('351add6a')) {
      api.createRecord('351add6a', component.options)
    } else {
      api.reload('351add6a', component.options)
    }
    module.hot.accept("./airBookingVessel.vue?vue&type=template&id=351add6a&scoped=true&", function () {
      api.rerender('351add6a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/SystemMaintenance/components/pageUICustom/airBookingVessel.vue"
export default component.exports